// ************************************************************************************************
// pathname: /v1/search-pack/activate
// ************************************************************************************************
import { useTranslation } from 'next-i18next';
import { useSwrMutationApi } from '@hooks/useSwrApi';
import { ApiRequestBody } from '@type/api/apiUtilityFn';

/** Hook props */
type UseSwrInstantlySearchpackReqBody = ApiRequestBody<'/v1/search-pack/activate', 'post'>;
interface UseSwrInstantlySearchpackProps {
  locale?: Locale;
  jobSlug: string;
  jobTitle: string;
  onSuccess?: () => void;
}

/**
 * @description Hook for activating a searchPack.
 * - `locale`: The current app locale.
 * - `jobSlug`: The job slug.
 * - `jobTitle`: The job title.
 * - `onSuccess`: Optional callback to execute on success.
 */
export const useSwrSearchpackActivateJob = (props: UseSwrInstantlySearchpackProps) => {
  const {
    jobSlug, jobTitle, onSuccess,
  } = props;
  const { t, i18n } = useTranslation('common');

  // SWR, activate the job
  return useSwrMutationApi<undefined, UseSwrInstantlySearchpackReqBody>({
    url: '/v1/search-pack/activate',
    locale: i18n.language,
    fetcherConfig: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      stringifyPayload: true,
      payload: {
        jobSlug,
        jobTitle,
      },
    },
    apiOptions: {
      onSuccess,
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText: t('my-jobs.toast.activate.searchpack'),
      showErrorToast: true,
    },
  });
};
